/**
 * Quantity Custom Input Initializer
 * This script ensures all quantity inputs are properly initialized
 */
(function() {
  "use strict";

  // Function to initialize a single quantity input
  function initQuantityInput(container) {
    const input = container.querySelector(".quantity-custom__input");
    const upButton = container.querySelector(".quantity-custom__button--up");
    const downButton = container.querySelector(".quantity-custom__button--down");

    if (!input || !upButton || !downButton) {
      console.error("Quantity input elements not found in:", container);
      return;
    }

    // Get min/max values
    const min = Number(input.getAttribute("min") || 1);
    const max = Number(input.getAttribute("max") || Infinity);

    // Force enable buttons
    upButton.removeAttribute("disabled");
    upButton.classList.remove("disabled");
    upButton.setAttribute("aria-disabled", "false");

    downButton.removeAttribute("disabled");
    downButton.classList.remove("disabled");
    downButton.setAttribute("aria-disabled", "false");

    // Update button states based on current value
    function updateButtonStates() {
      const currentValue = Number(input.value);

      // Disable up button if at max
      if (currentValue >= max) {
        upButton.setAttribute("disabled", "");
        upButton.classList.add("disabled");
        upButton.setAttribute("aria-disabled", "true");
      } else {
        upButton.removeAttribute("disabled");
        upButton.classList.remove("disabled");
        upButton.setAttribute("aria-disabled", "false");
      }

      // Disable down button if at min
      if (currentValue <= min) {
        downButton.setAttribute("disabled", "");
        downButton.classList.add("disabled");
        downButton.setAttribute("aria-disabled", "true");
      } else {
        downButton.removeAttribute("disabled");
        downButton.classList.remove("disabled");
        downButton.setAttribute("aria-disabled", "false");
      }
    }

    // We're now using inline onclick handlers, so we don't need these event listeners
    // Instead, just set up the input change handler and initial button states

    // Handle input change
    function onInputChange() {
      // Ensure the value is a valid number
      let value = Number(input.value);

      // If not a valid number, reset to minimum
      if (isNaN(value) || value === "") {
        value = min;
      }

      // Ensure value is within min/max bounds
      value = Math.max(min, Math.min(max, value));

      // Update the input if the value was changed
      if (Number(input.value) !== value) {
        input.value = value;
      }

      updateButtonStates();
    }

    // Add input change event listener
    input.addEventListener("change", onInputChange);
    input.addEventListener("input", onInputChange);

    // Initialize button states
    updateButtonStates();
  }

  // Function to initialize all quantity inputs on the page
  function initAllQuantityInputs() {
    const containers = document.querySelectorAll(".quantity-custom");
    containers.forEach(container => {
      initQuantityInput(container);
    });
  }

  // Initialize all quantity inputs on the page
  initAllQuantityInputs();

  // Initialize on DOMContentLoaded
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAllQuantityInputs);
  } else {
    // DOM already loaded, initialize now
    initAllQuantityInputs();
  }

  // Re-initialize when sections are updated (for Shopify section rendering)
  document.addEventListener("shopify:section:load", function(event) {
    const containers = event.target.querySelectorAll(".quantity-custom");
    containers.forEach(container => {
      initQuantityInput(container);
    });
  });
})();
